var map = {
	"./Accordion.svg": 469,
	"./Breadcrumb.svg": 470,
	"./Button.svg": 471,
	"./Checkbox.svg": 472,
	"./Code snippet.svg": 473,
	"./Content switcher.svg": 474,
	"./Data table.svg": 475,
	"./Date picker.svg": 476,
	"./Dropdown.svg": 477,
	"./File uploader.svg": 478,
	"./Form.svg": 479,
	"./Inline loading.svg": 480,
	"./Link.svg": 481,
	"./List.svg": 482,
	"./Loading.svg": 483,
	"./Modal.svg": 484,
	"./Multiselect.svg": 485,
	"./NoImage.svg": 305,
	"./Notification.svg": 486,
	"./Number input.svg": 487,
	"./Overflow menu.svg": 488,
	"./Pagination.svg": 489,
	"./Progress indicator.svg": 490,
	"./Radio button.svg": 491,
	"./Search.svg": 492,
	"./Select.svg": 493,
	"./Slider.svg": 494,
	"./Structured list.svg": 495,
	"./Tabs.svg": 496,
	"./Tag.svg": 497,
	"./Text input.svg": 498,
	"./Tile.svg": 499,
	"./Toggle.svg": 500,
	"./Tooltip.svg": 501,
	"./UI shell.svg": 502
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 468;